export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14905.51bb32ff.jpg";